import Vue from 'vue'
// the component
import Bsn from 'bootstrap.native'

Vue.prototype.$Bootstrap = {
  Button: Bsn.Button,
  Collapse: Bsn.Collapse,
  Modal: Bsn.Modal,
  Alert: Bsn.Alert
}
// export default Bootstrap
